import React from 'react';
import ModernResume from './components/ModernResume';
import './styles/globals.css';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <ModernResume />
    </div>
  );
}

export default App;